import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Custom type sizes must stay separate from shadcn text-color utilities.
const mergeClasses = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['hero', 'hero-desktop', 'page', 'section', 'subsection', 'card-title'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return mergeClasses(clsx(inputs));
}
